import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoPinterest = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 0 0-3.21 15.327 7.026 7.026 0 0 1 .138-1.837l1.03-4.359a3.073 3.073 0 0 1-.255-1.265c0-1.186.687-2.071 1.542-2.071a1.071 1.071 0 0 1 1.08 1.201 17.22 17.22 0 0 1-.708 2.838 1.238 1.238 0 0 0 1.263 1.541c1.516 0 2.536-1.947 2.536-4.253a2.995 2.995 0 0 0-3.328-3.066A3.788 3.788 0 0 0 4.15 7.888a2.31 2.31 0 0 0 .527 1.569.388.388 0 0 1 .115.446l-.163.642a.276.276 0 0 1-.4.2A3.081 3.081 0 0 1 2.59 7.688c0-2.272 1.917-4.997 5.717-4.997a4.78 4.78 0 0 1 5.064 4.582c0 3.138-1.744 5.483-4.316 5.483a2.294 2.294 0 0 1-1.954-.997s-.464 1.843-.563 2.199a6.697 6.697 0 0 1-.805 1.714A8 8 0 1 0 8 0z" />
    </g>
  );
};

export default withIcon(IconLogoPinterest);
